import T from '@wojtekmaj/react-t';

import { Image, ImageContainer, Text, Wave, WaveMask, Wrapper } from './slide.styles';

type SlideProps = {
  backgroundColor: string;
  current: number;
  fetchPriority?: 'auto' | 'high' | 'low';
  image: string;
  imageWebp?: string;
  imageAvif?: string;
  text: string;
  total: number;
};

export default function Slide({
  backgroundColor,
  current,
  fetchPriority,
  image,
  imageWebp,
  imageAvif,
  text,
  total,
}: SlideProps) {
  return (
    <Wrapper>
      <ImageContainer>
        <picture>
          <source srcSet={imageAvif} type="image/avif" />
          <source srcSet={imageWebp} type="image/webp" />
          <source srcSet={image} type="image/png" />
          <Image alt="" fetchPriority={fetchPriority} height={404} src={image} width={375} />
        </picture>
      </ImageContainer>
      <Wave current={current} total={total} />
      <WaveMask backgroundColor={backgroundColor} current={current} total={total} />
      <Text>
        <T>{text}</T>
      </Text>
    </Wrapper>
  );
}
